import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { colors } from '@sensei/pi-component';

const useTermsAndConditionsDialogStyles = makeStyles((theme: Theme) =>
    createStyles({
        dialogHeader: {
            flexDirection: 'row-reverse',
            position: 'relative',
            paddingRight: 0,
            paddingTop: theme.spacing(2),
            backgroundColor: colors.WHITE,
        },
        actions: {
            [theme.breakpoints.up('sm')]: {
                padding: theme.spacing(4, 8),
            },
            [theme.breakpoints.up('xs')]: {
                padding: theme.spacing(2, 2),
            },
        },
        actionButton: {
            [theme.breakpoints.up('xs')]: {
                fontSize: 11,
            },
        },
    }),
);

export default useTermsAndConditionsDialogStyles;
